import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { checkClientAuth, hasLocalLogin } from "./checkClientAuth";

const ClientAuthGuard = ({ children }) => {
  const [checking, setChecking] = useState(true);
  const [authorized, setAuthorized] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const verifyAuth = async () => {
      const ssoUser = await checkClientAuth();

      if (!isMounted) return;

      if (ssoUser) {
        setAuthorized(true);
        setChecking(false);
        return;
      }

      if (hasLocalLogin()) {
        setAuthorized(true);
        setChecking(false);
        return;
      }

      setChecking(false);
    };

    verifyAuth();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    if (!checking && !authorized) {
      window.location.href = "/login";
    }
  }, [checking, authorized]);

  if (checking) {
    return (
      <Spinner
        style={{ position: "absolute", top: "50%", left: "50%" }}
        id="authLoadingSpinner"
        animation="border"
        role="status"
      />
    );
  }

  if (!authorized) {
    return null;
  }

  return <>{children}</>;
};

export default ClientAuthGuard;

